const TEXT_ASSUNTO_DICAS = `Dicas para criar assuntos:

- Personalize com a variável do lead.
- Use palavras-chave relevantes.
- Adicione humor e perguntas intrigantes.
- Mantenha até 9 palavras.
- Limite a 3 sinais de pontuação.
- Evite palavras com aparência de spam.`;
export default { TEXT_ASSUNTO_DICAS };
